/* eslint-disable import/first */
/* eslint-disable import/first */
import React, { useState, useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { format } from 'date-fns';
import { Redux, Slices } from 'spwa-ui-library';
import { Grid, Divider, Typography, Button } from '@material-ui/core';
import { useNavigate, useLocation } from '@reach/router';
import { BsArrowClockwise } from '@react-icons/all-files/bs/BsArrowClockwise';
/* eslint-disable import/first */
const { useSelector } = Redux;
const { orderStatusConstants, selectCountryValidations } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
import { orderStatusHelper, decimalChecker } from 'spwa-ui-library/esm/utils/helper.js';
import ReOrder from '../../components/ReOrder';
import css from './index.module.scss';

const OrderInfo = ({ orderObj, page }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const childComponentRef = useRef();
  const intl = useIntl();
  const orderStatusArray = useSelector(orderStatusConstants);
  let menu = useSelector((state) => state.menu);
  const country = useSelector(selectCurrentCountry);
  const [isReorderEnabled, setEnableReOrder] = useState(false);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));

  menu = Object.values(menu?.entities || {})?.[0];

  const navigateOrderHandler = () => {
    if (!isReorderEnabled) {
      if (location?.state?.fromPage === 'feedback') {
        navigate(`/${intl.locale}/feedback`, {
          replace: true,
          state: {
            orderId: orderObj._id || orderObj,
            oldLocation: location?.state?.oldLocation,
          },
        });
      } else if (!location.pathname.includes('/feedback')) {
        navigate(`/${intl.locale}/order-detail/${orderObj._id}`, {
          state: {
            oldLocation: location?.state?.oldLocation,
          },
        });
      }
    }
  };

  let d =
    orderObj?.advanceTime === 0
      ? new Date(orderObj?.createdAt)
      : new Date(orderObj?.advanceTime); /* midnight in China on April 13th */
  const abs = d
    .toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
    .split(',');

  const formDate = `${d.getDate()} ${d.toLocaleDateString('en-US', {
    month: 'long',
  })}, ${d.getFullYear()} | ${abs[1]}`;

  const handleNavigation = (id, status, enableReorder) => () => {
    if (enableReorder) {
      setEnableReOrder((pre) => !pre);
      return;
    }
    if (status === 'PENDING') {
      navigate('/thank-you/' + id);
    } else {
      navigate('/track-order/' + id);
    }
  };
  // ENABLE REORDER CHECK COND
  let orderClusterId = `${orderObj?.menuId}_${orderObj?.menuTemplateId}`;
  let clusterId = `${menu?.menuId}_${menu?.menuTemplateId}`;
  const shouldEnableReorder =
    orderObj?.status === 'DELIVERED' &&
    page === 'history' &&
    countryValidations?.enableReorder &&
    orderClusterId == clusterId;

  useEffect(() => {
    return () => {
      setEnableReOrder(false);
    };
  }, []);

  useEffect(() => {
    if (childComponentRef && childComponentRef.current && isReorderEnabled) {
      childComponentRef.current.addCart();
    }
  }, [childComponentRef, isReorderEnabled]);

  let orderQty = orderObj?.itemIds.length || orderObj?.itemIdAndTypeIds?.length || orderObj?.qty;

  return (
    <Grid className={page === 'feedback' ? css.feedBackContainer : css.container}>
      <Grid className={css.root}>
        <div onClick={navigateOrderHandler}>
          <Grid className={css.orderCard}>
            <Grid className={css.textBackground}>
              <>
                {orderObj?.orderDisplayNumber ? (
                  <h5
                    className={`${css.orbNumber} ${
                      window.location.pathname.includes('order-history') ? css.smallText : ''
                    }`}
                  >
                    <FormattedMessage id={'orderdetails_orderno'} defaultMessage="Order No" />{' '}
                    <span className={css.redText}>{orderObj?.orderDisplayNumber}</span>
                  </h5>
                ) : null}
              </>
            </Grid>

            {location.state && location.state.fromPage === 'feedback' && (
              <Grid>
                <input
                  type="radio"
                  value=""
                  checked={location?.state?.orderId === orderObj?._id}
                  name="orderId"
                />
              </Grid>
            )}
          </Grid>
          <Grid>
            <Grid className={css.itemWrapper}>
              {page === 'feedback' ? (
                <>
                  <div className={css.itmImg}>
                    <img src={orderObj?.assets[0]?.src} alt="" />
                  </div>
                  <div className={css.feedbackItems}>
                    <Grid className={css.orderCount}>
                      {orderQty}
                      &nbsp;
                      {orderQty > 1 ? (
                        <FormattedMessage id="checkout_items" defaultMessage="Items" />
                      ) : (
                        <FormattedMessage id="checkout_item" defaultMessage="Item" />
                      )}
                    </Grid>
                    <Grid className={css.itemDescription}>{orderObj?.name}</Grid>
                  </div>
                </>
              ) : (
                <Grid className={css.orderCount}>
                  {orderQty}
                  &nbsp;
                  {orderQty > 1 ? (
                    <FormattedMessage id="checkout_items" defaultMessage="Items" />
                  ) : (
                    <FormattedMessage id="checkout_item" defaultMessage="Item" />
                  )}
                </Grid>
              )}

              {page !== 'feedback' &&
              orderObj?.status === 'PENDING' &&
              orderObj.advanceTime !== 0 ? (
                <>
                  |
                  <Grid className={css.advance}>
                    {`${
                      orderObj?.address?.addressSubType === 'STORE' &&
                      orderObj?.address?.addressType === 'PICKUP'
                        ? orderObj?.address?.addressType?.toUpperCase()
                        : orderObj?.address?.addressSubType?.toUpperCase() || 'Delivery'
                    } ${intl.formatMessage({
                      id: 'scheduled_for',
                    })} `}{' '}
                    {formDate}
                  </Grid>
                </>
              ) : (
                page !== 'feedback' && (
                  <>
                    |
                    <span
                      className={
                        orderObj?.status === 'PENDING' ? css.warningColor : css.orderStatus
                      }
                    >
                      {(orderObj?.address?.addressSubType === 'PICKUP' ||
                        orderObj?.address?.addressSubType === 'DINEIN' ||
                        orderObj?.address?.addressSubType === 'STORE') &&
                      orderObj?.status === 'ON_THE_WAY'
                        ? 'READY FOR PICKUP'
                        : orderStatusArray.length > 0 &&
                          orderStatusHelper(orderObj?.status, orderStatusArray).toUpperCase()}
                    </span>
                  </>
                )
              )}
            </Grid>
          </Grid>
          {page !== 'feedback' && <Grid className={css.itemDescription}>{orderObj?.name}</Grid>}
        </div>
        <Divider className={css.dividerArea} />
        <Grid className={css.flexBox}>
          <Typography className={css.amountTypo}>
            {decimalChecker(orderObj?.amount)} {countryValidations?.currency}
          </Typography>

          {page === 'feedback' ? (
            <div className={css.feedBackOrderStatus}>
              Order Status &nbsp;&nbsp;
              <span className={orderObj?.status === 'PENDING' ? css.warningColor : css.orderStatus}>
                {(orderObj?.address?.addressSubType === 'PICKUP' ||
                  orderObj?.address?.addressSubType === 'DINEIN' ||
                  orderObj?.address?.addressSubType === 'STORE') &&
                orderObj?.status === 'ON_THE_WAY'
                  ? 'READY FOR PICKUP'
                  : orderStatusArray.length > 0 &&
                    orderStatusHelper(orderObj?.status, orderStatusArray).toUpperCase()}
              </span>
            </div>
          ) : (
            <>
              {orderObj?.status !== 'DELIVERED' ? (
                <div className={css.button}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleNavigation(orderObj._id, orderObj.status)}
                  >
                    <FormattedMessage id="navigation_trackOrder" defaultMessage="Track Order" />
                  </Button>
                </div>
              ) : null}
            </>
          )}
          {isReorderEnabled && (
            <Grid className={css.reorder}>
              <ReOrder orderId={orderObj?._id} ref={childComponentRef} />
            </Grid>
          )}
          <div className={css.btnWrap}>
            {shouldEnableReorder && (
              <Button
                variant="outlined"
                color="primary"
                onClick={handleNavigation(orderObj?._id, orderObj?.status, shouldEnableReorder)}
              >
                <BsArrowClockwise className={css.styleClockIcon} />
                <FormattedMessage id="navigation_historyReOrder" defaultMessage="Re Order" />
              </Button>
            )}
          </div>
        </Grid>
        <Grid className={css.orderCard} style={{ marginTop: '2rem' }}>
          <Grid className={`${css.textBackground} ${css.blueBackground}`}>
            {orderObj?.status !== 'PENDING' ||
            (orderObj?.status === 'PENDING' && orderObj.advanceTime !== 0) ? (
              <>
                <FormattedMessage id="orderhistorylist_orderno" defaultMessage="Order no" />.
                <Grid style={{ display: 'flex' }}>
                  <Grid>
                    <span className={css.styleOrderInfor}>
                      {country} - {orderObj?.uOrderRef}{' '}
                    </span>
                    |
                  </Grid>
                  <Grid className={css.dateFormatter}>
                    <span>
                      {' '}
                      {orderObj?.createdAt && format(orderObj?.createdAt, 'dd LLL, yyyy')}
                    </span>
                  </Grid>
                </Grid>
              </>
            ) : (
              <strong>
                <FormattedMessage id="pendingConfirmation" defaultMessage="Pending Confirmation" />
              </strong>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrderInfo;
